import ConsoleAnalyticsClient from './ConsoleAnalyticsClient'
import GoogleTagManagerClient from './GoogleTagManagerClient'

const AnalyticsClient = (() => {
  if (process.env.GATSBY_ENV === 'dev') {
    return ConsoleAnalyticsClient()
  }
  return GoogleTagManagerClient()
})()

export default AnalyticsClient
